import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/Competence/CompetenceCommentApi.js";
import store from "../../../../Frontends/Common/store/index.js";
export class CompetenceCommentService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editCompetenceComment", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editCompetenceComment");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getCompetenceComments", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getCompetenceComment", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createCompetenceComment", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteCompetenceComment", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editCompetenceComment", model);
  }
  async export(filter, format) {
    let role = JSON.parse(localStorage.getItem("userRole")).systemName;
    const res = this.Api.export(filter, role, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
}
